// extracted by mini-css-extract-plugin
export var Author = "card-module--Author--b209f";
export var Author__Img = "card-module--Author__Img--9d689";
export var PostCard = "card-module--PostCard--88947";
export var PostCard__Content = "card-module--PostCard__Content--5ab4d";
export var PostCard__Img = "card-module--PostCard__Img--3269f";
export var category = "card-module--category--5a66d";